import { useCallback, useEffect, useState } from "react"
import { getGoDaddyData } from "../../../http/HostingHttp";
import Div from "../../../components/Div";
import { Pagination, Stack } from "@mui/material";
import PageTitle from "../../../components/PageTitle";
import Input from "../../../components/Input";
import FormButton from "../../../components/FormButton";
// import UpdateRenewalCustomerModal from "../../components/EditRenewalCustomerModal";
import SendNotificationModalGoDaddy from "../../../components/Renewal/SendNotificationModalGoDaddy";


export default function GoDadddy() {

    const [customerList, setCustomerList] =  useState([]);
    // const [isAscending, setIsAscending] = useState(true);
    // const [modalClicked, setModalClicked] = useState(false)
    const [initailCustomerList, setInitialCustomerList] = useState([])
    // const [googleCustomer, setGoogleCustomer] = useState([]);
    const [sendNotification, setSendNotification] = useState(false);
    const getCurrentYearMonth = () => {
        const date = new Date();
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
      };
    const [search, setSearch] = useState('');

    const [month, setMonth] = useState(getCurrentYearMonth);

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const currentItems = customerList.slice(indexOfFirstItem, indexOfLastItem);

    // Calculate total pages
    const totalPages = Math.ceil(customerList.length / itemsPerPage);

    // Change page
    const paginate = (event, value) => {
        setCurrentPage(value);
    };

    const getShivaamiDetail = useCallback( async () => {
        const response = await getGoDaddyData()
        if (response) {
            setCustomerList(response.customer)
            setInitialCustomerList(response.customer)   
            const currentYearMonth = getCurrentYearMonth();
            const filteredList = response.customer.filter((customer) => {
                if (customer && customer.renewal_date) {
                    // The date is in DD-MM-YYYY format, so we need to reformat it to YYYY-MM to match.
                    
                    const [year, month] = customer.renewal_date.split('-');
                    const formattedDate = `${year}-${month}`;
                    return formattedDate.includes(currentYearMonth);
                }
                return false;
            });

            setCustomerList(filteredList);
            setInitialCustomerList(response.customer);
        }
        else {
            window.location.href = '/error'
            alert('Could not fetch data. Please contact your Administrator')
        }
    }, []);

    useEffect(() => {
        getShivaamiDetail()
    }, [getShivaamiDetail])

    function handleSearchCustomer(event) {

        const search = event.target.value;
        const filteredList = initailCustomerList.filter((customer) => {
            if ((customer && customer.domain_name)) {

                return customer.domain_name.toLowerCase().includes(search.toLowerCase());
            }
            else {
                return false
            }
        });
        setSearch(search);
        setCustomerList(filteredList);
    }

    function handleMonthChange(event) {
        const filterMonth = event.target.value

        if (search) {
            const filteredList = initailCustomerList.filter((customer) => {

                if ((customer && customer.domain_name)) {
                    return customer.domain_name.toLowerCase().includes(search.toLowerCase());
                }
                else {
                    return false
                }
            }).filter((customer) => {

                if ((customer && customer.renewal_date)) {
                    const [year, month] = customer.renewal_date.split('-');
                    const formattedDate = `${year}-${month}`
                    return formattedDate.includes(filterMonth)
                }
                else {
                    return false
                }
            });

            setCustomerList(filteredList)
            setMonth(filterMonth)
        }
        else {
            // If no search term, just filter by month from the initial list
            const filteredList = initailCustomerList.filter(customer => customer && customer.renewal_date && customer.renewal_date.includes(filterMonth));
            setCustomerList(filteredList);
            setMonth(filterMonth)
        }
    }
    function handleSendNotification(domain_name, sr_no, description, email, expiry_date, invoice_type, mobile, phone) {
        const notifyData = {
            'domain_name': domain_name,
            'sr_no':sr_no,
            'description':description,
            "email":email,
            "expiry_date":expiry_date,
            "invoice_type":invoice_type,
            // "product_type":invoice_type,
            "mobile":mobile,
            "phone":phone
        }
        // console.log(notifyData);
        setSendNotification(notifyData);
        // console.log(currentItems);
        
    }
    return (
        <>
            {/* {modalClicked ? <UpdateRenewalCustomerModal customer={modalClicked} show={true.toString()} open handleClicked={setModalClicked} /> : null} */}
                {sendNotification ? <SendNotificationModalGoDaddy productList={currentItems} notify={sendNotification} show={true.toString()} open handleClicked={setSendNotification} /> : null}
            <PageTitle title='Go Daddy Data' />
            <Div className="col-md-12">
                <Div className="page-header-toolbar">

                    <Div className="btn-group toolbar-item" role="group" >
                        <Input type="text" name="email" id="email"
                            onChange={handleSearchCustomer}
                        />
                        <Input type='month' name='month' id='month' style={{ marginLeft: '50px' }} value={month}
                            onChange={handleMonthChange}
                        />

                    </Div>

                    <Div className="filter-wrapper">
                    </Div>
                    {/* <span>
                        <Dropdown>
                            <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic">
                                <BsFilter />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item
                                    onClick={() => handleStatusFilter('Active')}
                                >
                                    Active
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={() => handleStatusFilter('Rejected')}
                                >
                                    Rejected
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={() => handleStatusFilter('Suspended')}
                                >
                                    Suspended
                                </Dropdown.Item>

                            </Dropdown.Menu>

                        </Dropdown>

                    </span> */}
                </Div>
            </Div>

            <div
                
            >

            </div>

            <Div className="col-md-12 margin_top">
                {/* {currentPage} */}
                {currentItems ?
                    <>
                        <table className="table" border="1">
                            <thead>
                                <tr>
                                    <th>Domain Name</th>
                                    <th>Description</th>
                                    <th>Email</th>
                                    <th>Expiry Date</th>
                                    <th>Product</th>
                                    <th>Mobile</th>
                                    <th>Phone</th>
                                    <th> </th>

                                  
                                </tr>
                            </thead>
                            <tbody id="tableBody">
                                {currentItems.map((customer) =>

                                    <tr key={customer.subscription_id}>
                                        <td>
                                            {customer.domain_name}
                                            {/* <button onClick={()=>handlecustomerClick(customer.customer_id)} className="btn btn-link ">{customer.customer_name}</button> */}
                                        </td>
                                        <td>{customer.description}</td>
                                        <td>{customer.email}</td>
                                        <td>{customer.renewal_date}</td>
                                        <td>{customer.invoice_type}</td>
                                        <td>{customer.mobile}</td>
                                        <td>{customer.phone}</td>
                                        <td>
                                            <FormButton
                                            type='button'
                                            className="btn btn-link"
                                            onClick={() => handleSendNotification(customer.domain_name, customer.sr_no, 
                                                customer.description, customer.email, customer.renewal_date, customer.invoice_type, customer.mobile, customer.phone)}
                                            >
                                                {customer.notification_status ? 'Sent Notification': 'Send Notification'}
                                            </FormButton>
                                        </td>

                                    </tr>
                                )

                                }
                            </tbody>
                        </table>

                    </>
                    :
                    <>
                        <p style={{ marginTop : '30px' }}>Not Domain Present or Could not fetch Domains</p>
                    </>}

                {currentItems.length > 0 ?
                    <Stack spacing={2}>
                        <Pagination count={totalPages} color="primary" page={currentPage} onChange={paginate}>

                        </Pagination>
                    </Stack>
                    : null}
            </Div>

        </>
    )
}